import React from "react";
import "./App.css";
import Main from "./containers/Main";

function App() {
  return <Main theme={"light"} />;
}

export default App;
